// <!-- LEGAL REVIEW REQUIRED --> Template only. Placeholders are in LEGAL_TODO.md.
import React from 'react';
import { LegalList, LegalPage } from '../../components/ui';
import { COMPANY, CONTACT_EMAIL, LEGAL_UPDATED, MAILING_ADDRESS } from '../../lib/legal';

const SECTIONS = [
  {
    title: '1. Information We Collect on This Website',
    body: (
      <LegalList
        items={[
          'Contact and waitlist forms: your name, email, organization type, subject, and message.',
          'Job applications: the role, your name, email, and message.',
          'Pre-orders: your name, email, shipping address, and lens choice. Stripe collects your card details directly on its own checkout page. We never see or store your full card number.',
          'Prescription details, only if you order prescription lenses. We collect these separately before your glasses ship.',
          'Consent records: when you agreed to our terms and whether you opted in to marketing email.',
          'Server logs: IP address, browser type, pages requested, and time of request.',
        ]}
      />
    ),
  },
  {
    title: '2. What the Glasses and App Collect',
    body: (
      <>
        <LegalList
          items={[
            'Camera: Korsa Glasses do not have a camera.',
            'Microphone: the glasses capture audio, which may include the voices of people near you, in order to provide features like captions, translation, and recap.',
            'Cloud processing: raw audio is sent to a third-party service that converts speech to text. The text is then sent to a third-party AI language model for processing, and the result is sent to the Korsa app, which decides whether to display something. These providers are Deepgram, for speech to text, and Groq, for the AI language model. Groq does not keep the text it processes, except in temporary logs kept for up to 30 days to troubleshoot problems and prevent abuse. Deepgram may keep audio it processes and use it to improve its speech models, under its Model Improvement Program.',
            'Stored on your phone: the text of your conversations is stored on your phone so you can use summaries and search your day. We do not store microphone data long term on our servers.',
            'Deleting it: you can delete this data on the summaries page in the app, and uninstalling the app deletes all of it.',
            'Usage information: the app records which features you use and for how long, so it can show you your own usage. This stays on your phone. We do not use an outside analytics service, and this information is not sent to us.',
          ]}
        />
      </>
    ),
  },
  {
    title: '3. Why We Use It',
    body: 'We use personal information to respond to you, process and ship pre-orders, handle refunds, review job applications, send service messages, send marketing email if you opted in, keep our services secure, improve our products, and meet legal obligations. We do not sell your personal information, and we do not share it for cross-context behavioral advertising.',
  },
  {
    title: '4. How Long We Keep It',
    body: (
      <LegalList
        items={[
          'Server logs: about 10 days.',
          'Contact and waitlist messages: until you ask us to delete them, or until we no longer need them.',
          'Job applications: until you ask us to delete them, or until we no longer need them.',
          'Order, payment, and consent records: at least 7 years, for tax and accounting purposes.',
          'Marketing opt-in and opt-out records: as long as needed to honor your choice.',
        ]}
      />
    ),
  },
  {
    title: '5. Who We Share It With',
    body: (
      <LegalList
        items={[
          'Stripe, to process payments.',
          'Amazon Web Services, for hosting, data storage, and sending email.',
          'Google Workspace, for our business email.',
          'The speech and AI providers named in section 2, to run product features.',
          'Website analytics: we currently run none. If that changes, we will update this policy and our Cookie Notice first.',
          'Shipping carriers, once your order ships, and authorities or advisers when the law requires it.',
        ]}
      />
    ),
  },
  {
    title: '6. Your Rights',
    body: `You can ask us for access to, correction of, or deletion of your personal information by emailing ${CONTACT_EMAIL}. We may need to verify your identity, and we may keep records the law requires us to keep. We will respond within 45 days.`,
  },
  {
    title: '7. California Residents (CCPA/CPRA)',
    body: `California residents have the right to know what personal information we collect, use, and disclose; to request deletion; to correct inaccurate information; to opt out of sale or sharing; to limit the use of sensitive personal information; and not to be treated differently for exercising these rights. We do not sell or share personal information as those laws define it. To make a request, email ${CONTACT_EMAIL}. An authorized agent may make a request for you.`,
  },
  {
    title: '8. Children',
    body: `This website and our products are not directed to children under 13, and we do not knowingly collect their personal information. If you believe a child has given us information, email ${CONTACT_EMAIL} and we will delete it.`,
  },
  {
    title: '9. Security',
    body: 'Website traffic is encrypted in transit, and access to our systems is restricted. No system is completely secure, so we cannot guarantee absolute security.',
  },
  {
    title: '10. Changes to This Policy',
    body: 'We will post any changes on this page and update the date above. If a change materially affects how we use information we already hold, we will notify you by email.',
  },
  {
    title: '11. Contact Us',
    body: `${COMPANY}, ${MAILING_ADDRESS}. Email: ${CONTACT_EMAIL}.`,
  },
];

const Privacy = () => <LegalPage title="Privacy Policy" updated={LEGAL_UPDATED} sections={SECTIONS} />;

export default Privacy;
